import {ConfigProvider, message} from "antd";
import "antd/dist/antd.css";
import ruRU from "antd/lib/locale/ru_RU";
import {loadMessages, locale} from "devextreme/localization";
import ruMessages from "devextreme/localization/messages/ru.json";
import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {Route, HashRouter as Router, Switch} from "react-router-dom";
import {
  AuthClaimReadDto,
  Configuration,
  ModulesApi,
  UiApiAuthApi,
  UiApiClientsApi,
  UiApiGroupsApi,
  UiApiParticipantsApi,
  UiApiParticipantsUsersApi,
  UiApiUsersApi
} from "./api_client";
import "./App.css";
import {AUTH_COOKIE, BasePathUrl} from "./appsettings";
import DefaultLayout from "./components/default-layout/DefaultLayout";
import Loader from "./components/loader/Loader";
import NotAuthRoute from "./components/not-auth-route/not-auth-route";
import PrivateRoute from "./components/private-route/private-route";
import {authStore, Login} from "./features/auth";
import {routes} from "./pages/pages";
import ApiContext from "./utils/ApiContext";
import {getCookie} from "./utils/cookie";
import ModulesList from "./pages/modules-list/ModulesList";

const App = () => {
  const [isInit, setInit] = useState(false);
  const dispatch = useDispatch();

  locale("ru-RU");
  loadMessages(ruMessages);

  const getUserAccess = async (): Promise<boolean> => {
    const authCookie = getCookie(AUTH_COOKIE);
    const res = await fetch(`${BasePathUrl}/ui-api/auth/user-permissions`);
    const userClaims: AuthClaimReadDto[] = await res.json();
    dispatch(authStore.actions.setUserClaims(userClaims));
    return userClaims.some(({type, value}) => {
      return type === "access" && value === "accounts";
    });
  };

  useEffect(() => {
    const authCookie = getCookie(AUTH_COOKIE);
    if (authCookie) {
      getUserAccess()
        .then((isAllowed) => {
          if (isAllowed === true) {
            dispatch(authStore.actions.setIsAuth(true));
          } else {
            message.error("У вас недостаточно прав для доступа в модуль авторизации!");
          }
        })
        .finally(() => {
          setInit(true);
        });
    } else {
      setInit(true);
    }
  }, []);

  const config = new Configuration({
    basePath: BasePathUrl
  });

  if (isInit) {
    return (
      <ConfigProvider locale={ruRU}>
        <ApiContext.Provider
          value={{
            authApi: new UiApiAuthApi(config),
            usersApi: new UiApiUsersApi(config),
            groupsApi: new UiApiGroupsApi(config),
            clientsApi: new UiApiClientsApi(config),
            participantsApi: new UiApiParticipantsApi(config),
            participantsUsersApi: new UiApiParticipantsUsersApi(config),
            modulesApi: new ModulesApi(config)
          }}
        >
          <Router>
              <Switch>
                <NotAuthRoute path="/login" exact>
                  <Login />
                </NotAuthRoute>
                <NotAuthRoute path="/registration" exact>
                  <ModulesList />
                </NotAuthRoute>
                {routes.map(({ChildComponent, ...params}, index) => (
                  <PrivateRoute key={String(index) + params.path} {...params}>
                    <DefaultLayout>
                      <ChildComponent />
                    </DefaultLayout>
                  </PrivateRoute>
                ))}
              </Switch>
          </Router>
        </ApiContext.Provider>
      </ConfigProvider>
    );
  }
  return <Loader />;
};

export default App;
